// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.

import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import config from "config/config";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";

// Init PostHog before Sentry so posthog.sentryIntegration() can attach the
// session replay URL to outgoing Sentry events.

posthog.init(config.posthog.key, {
  api_host: "https://us.i.posthog.com",
  person_profiles: "always",
  autocapture: false,
  disable_session_recording: false,
  session_recording: {
    // WARNING: Only enable this if you understand the security implications
    recordCrossOriginIframes: true
  },
  loaded: (ph) => {
    if (config.environment === "staging") ph.debug();
  }
});

Sentry.init({
  dsn: config.sentryDsn,
  enabled: config.environment === "production",
  environment: "production",

  integrations: [
    posthog.sentryIntegration({ organization: "boompay" }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    })
  ],

  tracesSampleRate: 0.2,
  enableLogs: true,

  sendDefaultPii: true,

  debug: true
});
